<script>
import Vue from 'vue'
import { List } from 'vant'
import ProjectListItem from './ProjectListItem'
import { searchProjectList } from '~/api/community.api'

Vue.use(List)
export default {
  components: {
    ProjectListItem
  },
  props: {
    filter: {
      default: () => {
        return {}
      },
      type: Object
    }
  },
  data() {
    return {
      projectDetailUrl: process.env.PC_WORKER_URL + 'marketing-bigscreen/list?',
      projectList: [],
      isLoading: false,
      isLastPage: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.pageNo = 1
        this.projectList = []
        this.isLastPage = false
        this.getSearchProjectList()
      }
    }
  },
  created() {
    this.getSearchProjectList()
  },
  methods: {
    getSearchProjectList,
    toProjectDetail
  }
}

function toProjectDetail(projectId) {
  window.open(
    this.projectDetailUrl +
      `companyId=${this.$route.params.companyId}&itemId=${projectId}&defaultTab=project&isAutoOpenDrawer=true`,
    '_blank'
  )
}

async function getSearchProjectList() {
  const vm = this
  if (vm.isLastPage) return
  vm.isLoading = true

  const res = await searchProjectList({
    pageNo: vm.pageNo,
    pageSize: vm.pageSize,
    latitude: 31.25956,
    longititude: 121.52609,
    region: vm.filter.region ? vm.filter.region : '',
    style: vm.filter.style ? vm.filter.style : '',
    room: vm.filter.room || vm.filter.room === 0 ? vm.filter.room : '',
    sort: vm.filter.sort ? vm.filter.sort : '',
    // personId: 10917,
    companyId: this.$route.params.companyId,
    isdisplay: 'N',
    showProject: this.filter.showProject
  })
  vm.projectList = vm.projectList.concat(res)
  if (res.length < vm.pageSize) {
    vm.isLastPage = true
  }
  vm.pageNo++
  vm.isLoading = false
}
</script>

<template>
  <div class="project_list_list_components_container">
    <van-list
      v-model="isLoading"
      :finished="isLastPage"
      :offset="500"
      :immediate-check="false"
      @load="getSearchProjectList"
      finished-text="没有更多了"
    >
      <div
        v-for="(projectItem, index) in projectList"
        :key="index"
        @click="toProjectDetail(projectItem.projectId)"
        style="cursor: pointer;"
      >
        <ProjectListItem :project-item="projectItem" />
      </div>
    </van-list>
  </div>
</template>

<style lang="scss">
.project_list_list_components_container {
  overflow: auto;
  // height: calc(100vh - 360px);
}
</style>
